import reducer from "./reducer";
export { default as DigitalWarehouseFileTypes } from "./components/index";
export { default as digitalWarehouseFileTypesReducerName } from "./constants";
export default reducer;
